<template>
  <div class="common-bottom">
    <div class="container">
      <div class="row">
        <div class="col-xl-10 left">
          <img src="../../assets/imgs/logo.png" class="logo" alt="">
          <ul class="nav">
            <li>
              <router-link :to="{ name: 'home' }">
                首页
              </router-link>
            </li>
            <li>
              <router-link :to="{ name: 'projectcase' }">
                项目案例
              </router-link>
            </li>
            <li>
              <router-link :to="{ name: 'custom' }">
                定制开发
              </router-link>
            </li>
            <li>
              <router-link :to="{ name: 'newscenter' }">
                新闻中心
              </router-link>
            </li>
            <li>
              <router-link :to="{ name: 'about' }">
                关于我们
              </router-link>
            </li>
          </ul>
          <div class="info">
            <div class="tel">联系电话: <span>0351-7029900</span></div>
            <div class="email">邮箱: <span>qhckjjs@163.com</span></div>
            <div class="summary">
              <div class="adress">地址:<span>山西省太原市小店区南中环高新科技产业区山西软件园体育路西</span></div>
              <div class="copy">Copyright@山西权华昌科技有限公司</div>
              <div class="filings"><a href="https://beian.miit.gov.cn" target="_blank" rel="noopener noreferrer">晋ICP备2023027089号</a></div>
            </div>
          </div>
        </div>
        <div class="col-xl-2 right">
          <img src="../../assets/imgs/official-account.png" class="qr-code" alt="">
          <div class="text">扫码关注公众号</div>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
export default {

}
</script>

<style lang="scss" scoped>
.common-bottom {
  width: 100%;
  height: 400px;
  background: #1a2033;
}
.row {
  width: 100%;
  margin: 0;
  .left {
    text-align: left;
    .logo {
      margin-top: 70px;
    }
    .nav {
      margin-top: 50px;
      li {
        font-size: 16px;
        font-family: Source Han Sans SC;
        font-weight: 500;
        color: #adb4c1;
        margin-right: 71px;
        position: relative;
        a{
            color: #ADB4C1;
        }
      }
      li::after {
        position: absolute;
        content: "";
        width: 2px;
        height: 14px;
        border: 1px solid #47506d;
        right: -35px;
        top: 5px;
      }
      li:last-child::after {
        content: none;
      }
    }
    .info {
      margin-top: 70px;
      text-align: left;
      font-size: 14px;
      font-family: Source Han Sans SC;
      font-weight: 500;
      color: #6e737e;
      .tel {
        margin-bottom: 20px;
      }
      .email {
        margin-bottom: 20px;
      }
      .summary {
        display: flex;
        align-items: center;
        .copy {
          margin-left: 89px;
          font-size: 12px;
          font-family: Source Han Sans SC;
          font-weight: 500;
          color: #888e9b;
        }
        .filings {
          margin-left: 40px;
          a {
              font-size: 12px;
              font-family: Source Han Sans SC;
              font-weight: 500;
              color: #888e9b;
              text-decoration: none;
            }
        }
      }
    }
  }
  .right {
    text-align: right;
    .qr-code {
      margin: 191px 0 10px 0;
    }
    .text {
      margin-right: 12px;
      font-size: 14px;
      font-family: Source Han Sans SC;
      font-weight: 500;
      color: #bcc3d2;
    }
  }
}
@media (min-width: 1200px) {
  .container {
    max-width: 1200px;
    height: 100%;
    padding: 0;
  }
}
</style>
